import { render, staticRenderFns } from "./why.vue?vue&type=template&id=060540c0&scoped=true&"
import script from "./why.vue?vue&type=script&lang=js&"
export * from "./why.vue?vue&type=script&lang=js&"
import style0 from "./why.vue?vue&type=style&index=0&id=060540c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060540c0",
  null
  
)

export default component.exports